import { useEffect, useState } from "react";
import ReactInputMask from "react-input-mask";

export default function PopUp({ isOpen, tem, setIsOpenPopUp }) {
    let [userName, setUserName] = useState("");
    let [phone, setPhone] = useState("");
    let [expertise, setExpertise] = useState("");
    let [description, setDescription] = useState("");
    let [phoneError, setPhoneError] = useState(false);
    let [isInviteMemberVariant, setIsInviteMemberVariant] = useState(false);
    let [agreeChecked, setAgreeChecked] = useState(false);
    let [isSubmitted, setIsSubmitted] = useState(false); // состояние для отображения благодарности
    let [countdown, setCountdown] = useState(5); // таймер обратного отсчета
    
    const MAX_USER_NAME = 50;

    useEffect(() => {
        if (tem && tem.includes("Присоединяйся к нашей команде!")) {
            setIsInviteMemberVariant(true);
        }
    }, [tem]);

    // Таймер для автоматического закрытия
    useEffect(() => {
        let timer;
        if (isSubmitted && countdown > 0) {
            timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);
        } else if (isSubmitted && countdown === 0) {
            closePopUp();
        }
        
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [isSubmitted, countdown]);

    function _setUserName(_userName) {
        if (_userName.length <= MAX_USER_NAME) {
            setUserName(_userName);
        }
    }

    function _setPhone(_phone) {
        setPhone(_phone);
    }

    function clearState() {
        setUserName("");
        setPhone("");
        setExpertise("");
        setDescription("");
        setPhoneError(false);
        setAgreeChecked(false);
        setIsSubmitted(false);
        setCountdown(5);
    }

    function closePopUp() {
        clearState();
        setIsOpenPopUp(false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Проверяем телефон только при отправке
        const cleanPhone = phone.replace(/[^0-9]/g, '');
        if (cleanPhone.length !== 11) {
            setPhoneError(true);
            return;
        }
        
        setPhoneError(false);

        const formData = {
            name: userName,
            tel: phone,
            type: expertise,
            text: description,
        };

        try {
            const response = await fetch("https://rusnekc.ru/mail.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            
            if (response.ok) {
                console.log("Success:", result);
                setIsSubmitted(true); // Показываем сообщение об успешной отправке
            } else {
                console.error("Error:", result);
                alert("Произошла ошибка при отправке. Попробуйте позже.");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Произошла ошибка при отправке. Попробуйте позже.");
        }
    };

    return (
        <div
            onClick={closePopUp}
            className={isOpen ? "modal opened" : "modal"}>
            <div onClick={(e) => e.stopPropagation()} className="modal-body">
                {!isSubmitted ? (
                    // Обычная форма
                    <>
                        <div className="popup_logo">
                            <img src={process.env.PUBLIC_URL + "/img/popup/logo.png"} alt="Логотип" />
                        </div>

                        <div className="popup_inform">
                            <p className="subtitle">{tem}</p>
                            <form className="popup_form" onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Имя *"
                                    required
                                    value={userName}
                                    onChange={(e) => _setUserName(e.target.value)}
                                    maxLength={MAX_USER_NAME}
                                />
                                
                                <ReactInputMask
                                    required
                                    placeholder="+7 (999) 999 99 99"
                                    mask="+7 (999) 999 99 99"
                                    type="tel"
                                    name="phone"
                                    value={phone}
                                    onChange={(e) => _setPhone(e.target.value)}
                                />
                                {phoneError && (
                                    <p className="error user_phone error_show">
                                        Введите корректный номер телефона (11 цифр)!
                                    </p>
                                )}
                                
                                {!isInviteMemberVariant && (
                                    <select
                                        placeholder="Экспертиза *"
                                        name="type"
                                        required
                                        value={expertise}
                                        onChange={(e) => setExpertise(e.target.value)}>
                                        <option value="" disabled>
                                            Экспертиза *
                                        </option>
                                        <option value="Лаборатория строительно-технических и землеустроительных экспертиз">
                                            Лаборатория строительно-технических и землеустроительных экспертиз
                                        </option>
                                        <option value="Лаборатория автотехнических и комплексных технических экспертиз">
                                            Лаборатория автотехнических и комплексных технических экспертиз
                                        </option>
                                        <option value="Лаборатория товароведческих и финансово-экономических экспертиз">
                                            Лаборатория товароведческих и финансово-экономических экспертиз
                                        </option>
                                        <option value="Лаборатория криминалистических и комплексных экспертиз">
                                            Лаборатория криминалистических и комплексных экспертиз
                                        </option>
                                    </select>
                                )}
                                
                                <textarea
                                    className="input_text"
                                    maxlength="300"
                                    name="text"
                                    placeholder={isInviteMemberVariant ? "Сопроводительное письмо" : "По какому вопросу вы хотите получить консультацию"}
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}>
                                </textarea>
                                
                                <div className="popup_description description">
                                    <input 
                                        required 
                                        type="checkbox" 
                                        id="checkbox1" 
                                        checked={agreeChecked}
                                        onChange={(e) => setAgreeChecked(e.target.checked)}
                                    />
                                    <label htmlFor="checkbox1">
                                        Отправляя заявку, Вы соглашаетесь с{" "}
                                        <a className="privacy_policy" href="/privacy">политикой конфиденциальности</a>
                                    </label>
                                </div>
                                
                                <button type="submit" className="blue_button button">
                                    Отправить
                                    <img src={process.env.PUBLIC_URL + "/img/fourth_block/button_arrow.png"} alt="стрелка на кнопке" />
                                </button>
                            </form>
                        </div>
                    </>
                ) : (
                    // Сообщение об успешной отправке
                    <div className="popup_success">
                        <div className="popup_logo">
                            <img src={process.env.PUBLIC_URL + "/img/popup/logo.png"} alt="Логотип" />
                        </div>
                        <div className="success_content">
                            <div className="success_icon">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="40" cy="40" r="38" stroke="#4CAF50" strokeWidth="3" fill="white"/>
                                    <path d="M25 40L35 50L55 30" stroke="#4CAF50" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="title">Спасибо за заявку!</h3>
                            <p className="description">
                                Мы свяжемся с Вами в ближайшее время!
                            </p>
                            <p className="description">
                                Закрытие через {countdown} секунд...
                            </p>
                            <button 
                                onClick={closePopUp} 
                                className="blue_button button"
                            >
                                Закрыть сейчас
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}